import React, { Component } from 'react'
import Dialog from 'react-bootstrap-dialog'
import { connect } from 'react-redux'
import { withRouter } from 'react-router-dom'
import Loader from 'react-loader-advanced'
import * as Constants from '../../../../common/constants'
import { menuTableReady } from '../../redux/menus'
import { buildNumberUpdate, } from '../../../../redux/user'
import apiService from '../../services/apiservices'



import {Products} from '../../../../common/DropDowns/index'


//import * as Helpers from '../../../../common/helpers'


class AddSkuModalLayout extends Component {
    constructor() {
        super()
        this.state = {
            isUpdating: false,
            productId: '',
            weight:'',

            productIdErrorText: false,
            productIdErrorData: '',

            weightErrorText: false,
            weightErrorData: '',

        }
        this.dialog = null

        this.isComponentStillMount = true

        this.productIdComponent = null
        this.productIdSection = null

        this.weightComponent = null
        this.weightSection = null
    }

    componentWillMount() {
        this.isComponentStillMount = true

        this.setState({
            productId:this.props.data.product_id,
            weight:this.props.data.weight,
        });


    }

    componentDidMount() {

    }



mandateValidation = (inputName, type) => {
    let inputComponent = inputName + "Component"
    let inputErrorText = inputName + "ErrorText"
    let inputErrorData = inputName + "ErrorData"
    let inputSection = inputName + "Section"
    let errorMsg = Constants.NON_VALID_MSG_INPUT
    if (Constants.FORM_SELECT === type) {
        errorMsg = Constants.NON_VALID_MSG_SELECT
        console.log("input name :::", inputName)
        console.log("input data :::", this.state[inputName])
    }
    if (this.state[inputName] === null || this.state[inputName] === undefined || this.state[inputName] === "") {
        this[inputComponent].focus()
        this.setState({
            [inputErrorText]: true,
            [inputErrorData]: errorMsg
        })
        this[inputSection].className = this[inputSection].className.replace(" has-error", "")
        this[inputSection].className += " has-error"
        return {
            status: false,
            value: ''
        }
    }
    return {
        status: true
    }
}

    validateBuildNumber = (data) => {
        if (this.props.user && this.props.user.build_number && data && data.app_build_no) {
            if (this.props.user.build_number === data.app_build_no) {
                //do smthng here
            } else {
               this.props.dispatch(buildNumberUpdate(data.app_build_no))
window.location.reload()
            }
        } else {
            this.props.dispatch(buildNumberUpdate(data.app_build_no))
window.location.reload()
        }
    }

    componentWillUnmount() {
        this.isComponentStillMount = false
    }




    productsChange= (data) => {
    this.productIdComponent.value=data.value
        this.setState({
            productId :data.value,
            productIdErrorText: false,
            productIdErrorData: '',
        })
        this.productIdSection.className= this.productIdSection.className.replace(" has-error", "")

    }




    

    handleOnSubmit = (e) => {

        e.preventDefault();

        this.props.dispatch(menuTableReady(false))
        let data = {}


        let weightObject = this.mandateValidation("weight", Constants.FORM_INPUT)
        if (weightObject.status) {
            data.weight=this.weightComponent.value         

        } else {
            this.props.dispatch(menuTableReady(true))
            return
        }


        let productIdObject = this.mandateValidation("productId", Constants.FORM_INPUT)
        if (productIdObject.status) {
            data.product_id=this.productIdComponent.value         

        } else {
            this.props.dispatch(menuTableReady(true))
            return
        }


    let apiPayloadData=data;


    apiService.editMenu(apiPayloadData,this.props.data.id)
            .then(responseData => {
                 
                    if (responseData.status === "SUCCESS") {
                        this.props.dispatch(menuTableReady(true))
                        this.props.closeModal(false)
                        window.location.reload()
                    } else {

                        this.props.dispatch(menuTableReady(true))
                        this.dialog.show({
                            title: "Alert",
                            body: responseData.reason ? responseData.reason : "",
                            actions: [
                                Dialog.OKAction(() => {
                                })
                            ],
                        })
                    }
                
            })
            .catch(err => {
                this.props.dispatch(menuTableReady(true))
                console.error("Error data: ", err)
               alert("exception"+ err);
            })




}



  
    render() {

        return (
            <div className="qr-code-reader-modal" style={{maxHeight:"600px"}}>
                <Dialog ref={el => this.dialog = el} />
                <Loader
                    show={this.state.isUpdating}
                    message={'Updating...Please wait'}
                    foregroundStyle={{ color: "#ffffff", fontSize: "17px", fontWeight: "600" }}>
                    <div className="modal-header">
                        <button type="button" className="close"
                            onClick={(e) => {
                                e.preventDefault()
                                this.props.closeModal(false)
                            }}>
                            <span>&times;</span></button>
                        <h4 className="modal-title" style={{textAlign:"center"}}>{this.props.title} Weight and SKU <br/>[ {this.props.data.name} - {this.props.data.up_id} - {this.props.data.city} ]</h4>
                    </div>

                    <div className="modal-body" style={{ height: "200px"}}>
                            <div className="form-horizontal">
                                <div className="col-md-12 col-sm-12 col-xs-12">
                                        
                                        <div className="col-md-11 col-sm-12 col-xs-12">
                                            <div className="form-group" ref={el =>
                                               this.weightSection = el}>
                                               <label className="col-sm-4 control-label labels" style={{textAlign: "right", paddingTop: "0px"}}>Weight (gms) *</label>
                                               <div className="col-sm-8">
                                                  <input className="form-control" placeholder="Enter Menu Weight" type="number" ref={el => this.weightComponent = el}
                                                  onChange={(e) => {e.preventDefault() 
                                                  this.keyedInputChange("weight")}} />
                                                  <span className="help-block" style={{ display: this.state.weightErrorText ? 'block' : 'none', marginTop: '0px', marginBottom: '0px' }}>
                                                  {this.state.weightErrorData}
                                                  </span>
                                               </div>
                                            </div>
                                         </div>   


                            </div>
                                <div className="col-md-12 col-sm-12 col-xs-12">
                                        
                                        <div className="col-md-11 col-sm-12 col-xs-12">
                                            <div className="form-group" ref={el => this.productIdSection = el}>
                                                <label className="col-sm-4 control-label labels" style={{textAlign: "right", paddingTop: "0px"}}>Select Product Kit *</label>
                                                <div className="col-sm-8" ref={el => this.productIdComponent = el}>
                                                <Products type="kit" city={this.props.data.city_id} productsChange={this.productsChange} selectedValue={this.state.productId} />
                                                <span className="help-block"style={{display: this.state.productIdErrorText ? 'block' : 'none',marginTop: '0px', marginBottom: '0px' }}>
                                                            {this.state.productIdErrorData}
                                                        </span>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>


                            </div>
                    </div>
                    <div className="modal-footer" style={{marginTop: "13%"}}>
                        <button type="button" className="btn btn-primary pull-left"
                            onClick={(e) => {
                                e.preventDefault()
                                this.props.closeModal(false)
                            }}>Close</button>
                            <button
                                    className="btn btn-info pull-right"
                                    style={{ width: "auto" }}
                                    onClick={(e) => {
                                        e.preventDefault()
                                        this.handleOnSubmit(e);
                                    }} >
                                    Submit
                                </button>
                    </div>

            </Loader>
            </div>
        )
    }


    keyedInputChange = (keyedName) => {
        console.log(keyedName)
        let keyedComponent =keyedName+"Component"
        let keyedErrorText =keyedName+"ErrorText"
        let keyedErrorData =keyedName+"ErrorData"
        let keyedSection =keyedName+"Section"
        let name=this[keyedComponent].value.trim()
        this.setState({[keyedName]:name})
        if(!name){
            this.setState({[keyedName] : null})
            return
        }
        this.setState({ [keyedErrorText]: false, [keyedErrorData]: '' })
        this[keyedSection].className = this[keyedSection].className.replace(" has-error", "")
    }
}

function mapStateToProps(state) {
    return {
        user: state.user,
        menus: state.menus,
    }
}

export default connect(mapStateToProps)(withRouter(AddSkuModalLayout))


// WEBPACK FOOTER //
// ./src/modules/Menus/Components/ModalLayout/AddSkuModalLayout.js